module.exports = __webpack_public_path__ + "img/11.4fd6e53b.png";